import React, { useState } from 'react';
import { X } from 'lucide-react';
import StripeSubscriptionPaymentForm from '../vendor/StripeSubscriptionPaymentForm';
import ModalShell from './ModalShell';

const PaymentModal = ({
  isOpen,
  onClose,
  selectedPlan,
  billingInterval = 'monthly',
  checkoutAmount,
  onPaymentSuccess,
  onPaymentError,
}) => {
  const [cardholderName, setCardholderName] = useState('');

  const open = Boolean(isOpen && selectedPlan);

  const handlePaymentSuccess = (data) => {
    if (onPaymentSuccess) {
      onPaymentSuccess(data);
    }
  };

  const handlePaymentError = (error) => {
    if (onPaymentError) {
      onPaymentError(error);
    }
  };

  return (
    <ModalShell
      isOpen={open}
      onClose={onClose}
      labelledBy="payment-modal-title"
      panelClassName="max-w-md"
    >
      {selectedPlan && (
        <div className="relative w-full overflow-hidden rounded-md border border-border bg-surface p-4 shadow-sm sm:p-5">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 rounded-md p-1 text-ink-tertiary transition-colors hover:bg-surface-muted hover:text-ink"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>

          <h3
            id="payment-modal-title"
            className="mb-3 pr-8 text-base font-semibold text-ink"
          >
            Complete Your Subscription
          </h3>

          <div className="mb-4">
            <h4 className="mb-1.5 text-xs font-medium text-ink">
              Selected Plan
            </h4>
            <div className="rounded-md border border-border bg-surface-muted p-3">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-ink">
                  {selectedPlan.name}
                </span>
                <span className="whitespace-nowrap text-sm font-semibold text-ink">
                  ${Number(checkoutAmount ?? selectedPlan.price ?? 0).toFixed(2)}
                  <span className="ml-1 text-xs font-normal text-ink-secondary">
                    /{billingInterval === 'yearly' ? 'year' : 'month'}
                  </span>
                </span>
              </div>
              <p className="mt-1 text-xs text-ink-secondary">
                {selectedPlan.description}
              </p>
            </div>
          </div>

          <StripeSubscriptionPaymentForm
            key={`${selectedPlan.id}-${billingInterval}-${checkoutAmount}`}
            subscriptionId={selectedPlan.id}
            billingInterval={billingInterval}
            amount={checkoutAmount ?? selectedPlan.price}
            onSuccess={handlePaymentSuccess}
            onError={handlePaymentError}
            metadata={{
              cardholderName: cardholderName,
              onCardholderNameChange: setCardholderName,
            }}
          />
        </div>
      )}
    </ModalShell>
  );
};

export default PaymentModal;
